export const handleSwiperProgressBar = (el, swiper) => {
    const progressEl = el.querySelector('[js-progress]');
    if (!progressEl) return;

    const updateProgress = () => {
        let progress;

        if (swiper.params.slidesPerView === 'auto') {
            progress = swiper.isLocked ? 1 : swiper.progress;
        } else {
            const slidesPerView = Number(swiper.params.slidesPerView) || 1;
            const maxIndex = Math.max(swiper.slides.length - slidesPerView, 0);

            progress =
                maxIndex === 0 ? 1 : (swiper.realIndex + 1) / (maxIndex + 1);
        }

        progressEl.style.width = `${Math.min(Math.max(progress, 0), 1) * 100}%`;
    };

    swiper.on('init', updateProgress);
    swiper.on('slideChange', updateProgress);
    swiper.on('resize', updateProgress);
    swiper.on('progress', updateProgress);
    swiper.on('setTranslate', updateProgress);

    updateProgress();
};
export const swiperProductGalleryPagination = el => {
    return {
        pagination: {
            bulletActiveClass: 'bg-grey-900!',
            bulletClass:
                'inline-block w-[12px] h-[12px] m-0! rounded-full bg-grey-400 opacity-100 cursor-pointer pointer-events-auto transition-colors duration-200',
            el,
            clickable: true,
            renderBullet(index, className) {
                return `<span class="${className}" aria-label="Slajd ${index + 1}"></span>`;
            },
        },
    };
};

export const swiperPagination = el => {
    return {
        pagination: {
            bulletActiveClass: 'bg-background-accent! cursor-auto!',
            bulletClass: 'bg-background-secondary',
            el: el,
            clickable: true,
            renderBullet: function (index, className) {
                return `<span class="flex-1 cursor-pointer h-[4px] ${className}"></span>`;
            },
        },
        on: {
            slideChange(swiper) {
                const bullets = swiper.pagination.bullets;

                bullets.forEach((bullet, i) => {
                    if (i <= swiper.activeIndex) {
                        bullet.classList.add('bg-background-accent!');
                        bullet.classList.remove('bg-background-secondary');
                    } else {
                        bullet.classList.remove('bg-background-accent!');
                        bullet.classList.add('bg-background-secondary');
                    }
                });
            },
        },
    };
};

export const swiperProductGalleryThumbnailsNavigation = el => {
    return {
        navigation: {
            disabledClass: 'swiper-button-disabled',
            nextEl: el?.querySelector('.-next'),
            prevEl: el?.querySelector('.-prev'),
        },
    };
};

export const swiperNavigation = el => {
    return {
        navigation: {
            disabledClass: 'opacity-0!',
            nextEl: el.querySelector('.-next'),
            prevEl: el.querySelector('.-prev'),
        },
    };
};
